import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

class Login extends React.Component {

  componentWillMount() {
    // use the existing login page for now
    window.location = 'https://account.goguardian.com/#/?product=' + this.props.productId;
  }

  render() {
    return null;
  }
};

const mapStateToProps = (state) => {
  return {
    productId: state.setProduct
  }
};

export default connect(mapStateToProps)(Login);



/** WEBPACK FOOTER **
 ** ./src/app/components/login/index.jsx
 **/